import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

export default function ItemNotFoundModal({
  onClose,
  title = "Item Not Found",
  message = "The barcode you scanned was not found. Try scanning again or searching for it manually.",
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
}) {
  const hasAction = actionLabel && onAction;
  const hasSecondaryAction = secondaryActionLabel && onSecondaryAction;

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <IconButton
        onClick={onClose}
        size="small"
        aria-label="Close"
        sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight={200}
          p={3}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: 48, mb: 2 }} />
          <Typography fontSize={20} fontWeight={500} color="error" align="center">
            {title}
          </Typography>
          <Typography
            color="textSecondary"
            align="center"
            sx={{ mb: hasAction || hasSecondaryAction ? 3 : 0 }}
          >
            {message}
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap" justifyContent="center">
            {hasSecondaryAction && (
              <Button variant="outlined" onClick={onSecondaryAction}>
                {secondaryActionLabel}
              </Button>
            )}
            {hasAction && (
              <Button variant="contained" onClick={onAction}>
                {actionLabel}
              </Button>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

ItemNotFoundModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  secondaryActionLabel: PropTypes.string,
  onSecondaryAction: PropTypes.func,
};
